import { useMemo } from 'react';
import useNavigationMenus from './useMenus';
import { PowerBiReportDetails } from 'common/models/power-bi.model';

interface UsePowerBiReport {
  isPowerBiReport: boolean;
  reportDetails: PowerBiReportDetails | null;
}

function usePowerBiReport(): UsePowerBiReport {
  const { currentPageMenuItem, currentSubPageMenuItem, currentTabMenuItem } = useNavigationMenus();

  const reportDetails = useMemo(() => {
    if (currentTabMenuItem?.powerBIReportID) {
      return {
        pageName: currentTabMenuItem.powerBIPageName ?? '',
        reportId: currentTabMenuItem.powerBIReportID,
      };
    }

    if (currentSubPageMenuItem?.powerBIReportID) {
      return {
        pageName: currentSubPageMenuItem.powerBIPageName ?? '',
        reportId: currentSubPageMenuItem.powerBIReportID,
      };
    }

    if (currentPageMenuItem?.powerBIReportID) {
      return {
        pageName: currentPageMenuItem.powerBIPageName ?? '',
        reportId: currentPageMenuItem.powerBIReportID,
      };
    }

    return null;
  }, [currentPageMenuItem, currentSubPageMenuItem, currentTabMenuItem]);

  return {
    isPowerBiReport: !!reportDetails,
    reportDetails,
  };
}

export default usePowerBiReport;
